// extracted by mini-css-extract-plugin
export var locationCard = "_i7-0";